module.exports = __webpack_public_path__ + "static/media/banner_indique_amigo.062c6d57.png";